export default "__VITE_ASSET__DzBIokcA__"